import React from 'react';
import { RecoilRoot } from 'recoil'
import App from './App';
import * as serviceWorker from './serviceWorker';

import {render} from 'react-snapshot'

render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
